<template>
  <div
    class="accordion col col-lg-2 mx-lg-0 p-0 sticky-top bg-white"
    v-if="selection.filterShow"
  >
    <div id="filterBody" class="accordion-collapse collapse show">
      <div class="accordion sticky-top" id="filterAccordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingFilter">
            <button
              class="accordion-button bg-light"
              id="filter"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#FilterCollapse"
              aria-expanded="false"
              aria-controls="FilterCollapse"
            >
              Filter
            </button>
          </h2>
          <div
            id="FilterCollapse"
            class="accordion-collapse collapse"
            :class="{ show: openAccordion }"
            aria-labelledby="headingFilter"
          >
            <div class="accordion-item" v-if="selection.colorShow">
              <h2 class="accordion-header" id="headingKleur">
                <button
                  class="accordion-button bg-light color"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#kleurCollapse"
                  aria-expanded="false"
                  aria-controls="kleurCollapse"
                >
                  kleur
                </button>
              </h2>
              <div
                id="kleurCollapse"
                class="accordion-collapse collapse"
                :class="{ show: openAccordion }"
                aria-labelledby="headingKleur"
              >
                <div class="accordion-body accordion-height p-0 mb-1">
                  <fieldset class="d-flex flex-column">
                    <div class="d-inline-flex flex-wrap" id="">
                      <div
                        class="colorInput me-1 mt-3 no-select"
                        id="btn-color-All"
                        @mouseup="setColorFilter('color', '')"
                      >
                        <img
                          id="imgAlleKleuren"
                          class="colorImg checkedMark"
                          src="https://cdn1.iconfinder.com/data/icons/onebit/PNG/onebit_34.png"
                        />
                      </div>
                      <template
                        v-for="(color, key) in selection.color"
                        :key="key"
                      >
                        <div
                          class="colorInput me-1 mt-3 no-select"
                          :id="'btn' + color"
                          @mouseup="setColorFilter('color', color)"
                        >
                          <img
                            class="colorImg"
                            :id="'img' + color"
                            src="https://cdn1.iconfinder.com/data/icons/onebit/PNG/onebit_34.png"
                          />
                        </div>
                      </template>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="selection.collectionShow">
              <h2 class="accordion-header" id="headingNaam">
                <button
                  class="accordion-button bg-light"
                  id="coll"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#naamCollapse"
                  aria-expanded="false"
                  aria-controls="naamCollapse"
                >
                  collectie
                </button>
              </h2>
              <div
                id="naamCollapse"
                class="accordion-collapse bg-light collapse"
                :class="{ show: openAccordion }"
                aria-labelledby="headingNaam"
              >
                <div class="accordion-body">
                  <select
                    class="form-select"
                    v-model="binds.route"
                    @change="changeCollectie(binds.route)"
                  >
                    <option selected id="all-coll" :value="pathAll">
                      Alle collecties
                    </option>
                    <template
                      v-for="(collectie, key) in selection.collection"
                      :key="key"
                    >
                      <option :value="collectie.path">
                        {{ collectie.label }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
            <template v-for="(option, key) in options" :key="key">
              <Options
                v-if="option.properties.show"
                :options="option"
                v-on:selected="selected"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import units from "@/json/units";
import Options from "@/components/FilterOptions.vue";
// TO DO add filters.json to vue return object
import selections from "@/json/views/filters.json";

export default {
  props: {
    products: Object,
  },
  components: {
    Options,
  },
  emits: ["filterd"],
  data() {
    return {
      selections: {},
      pathAll: "Kies collectie",
      selection: {
        color: [],
        colorShow: true,
        collection: [],
        collectionShow: true,
        filterShow: true,
      },
      options: {},
      binds: {
        color: "FSC",
        route: "",
      },
      filterResults: {
        color: {},
        rol: {},
        rug: {},
        methode: {},
        final: {},
      },
      openAccordion: false,
    };
  },
  created() {
    this.selection.collection = this.buildCollectie();
    if (this.selection.collection.length <= 1) {
      this.selection.collectionShow = false;
    }

    this.showFilter();

    // Check if the media query is true
    if (window.matchMedia("(min-width: 400px)").matches) {
      // Then trigger to open Accordion
      this.openAccordion = true;
    }

    this.binds.route = this.$route.name;
  },
  beforeUpdate() {
    this.showFilter();
  },
  updated() {
    this.$store.commit("storeLocUpdate", true);
  },
  mounted() {
    if (this.selection.colorShow) {
      document.querySelector("#imgAlleKleuren").style.display = "block";
      if (this.binds.color !== "FSC") {
        this.setColorBtn();
      }
    }
  },
  methods: {
    buildColors(products) {
      let colors = [];

      if (products !== undefined) {
        let iColorOptions = 0;

        for (const product in products) {
          if (
            !colors.includes(products[product].kleurFilter) &&
            products[product].kleurFilter !== ""
          ) {
            colors[iColorOptions] = products[product].kleurFilter;
            iColorOptions++;
          }
        }
      }
      this.setColorBtn();
      return colors;
      // end buildColors
    },

    buildCollectie() {
      // Naam aka collections

      const selection = this.$Functions.getSelection(this.$route.name);
      const collectionsData = this.$Functions.getData(
        `${selection.assortmentCode.toLowerCase()}/collections`,
        this.$store.getters.getLang
      );

      let collections = [];

      for (let index in collectionsData) {
        collections[index] = {
          label: collectionsData[index].label,
          path: `${selection.lang}-${selection.assortmentCode}${collectionsData[index].code}`,
        };
      }

      this.pathAll = `${selection.lang}-${selection.assortmentCode}ALL`;

      return collections;
    },

    buildFilter(products) {
      let options = {
        rol: {
          selectors: {
            class: `show:${this.openAccordion} ${selections.rol.selectors.class}`,
            id: selections.rol.selectors.id,
          },
          properties: { values: [], unit: "", show: false, key: "rol" },
        },
        rug: {
          selectors: {
            class: `show:${this.openAccordion} ${selections.rug.selectors.class}`,
            id: selections.rug.selectors.id,
          },
          properties: { values: [], unit: "", show: false, key: "rug" },
        },
        methode: {
          selectors: {
            class: `show:${this.openAccordion} ${selections.methode.selectors.class}`,
            id: selections.methode.selectors.id,
          },
          properties: { values: [], unit: "", show: false, key: "methode" },
        },
      };

      if (products !== undefined) {
        let iRolOptions = 0;
        let iRug = 0;
        let rug = [];
        let iMethode = 0;
        let methode = [];

        for (const product in products) {
          // type is rol
          if (products[product].rolBreedte[0] !== "") {
            // selections.rol.properties.show = true;

            // type rol unit
            if (products[product].rolBreedteEenheid !== "") {
              if (products[product].rolBreedteEenheid.toLowerCase() == "m") {
                options.rol.properties.unit = units.metric.distances.meter;
              }
              if (products[product].rolBreedteEenheid.toLowerCase() == "cm") {
                options.rol.properties.unit = units.metric.distances.centimeter;
              }
            }

            // type rol options
            for (const rolSize in products[product].rolBreedte) {
              if (
                !options.rol.properties.values.includes(
                  products[product].rolBreedte[rolSize]
                ) &&
                products[product].rolBreedte[rolSize] !== ""
              ) {
                options.rol.properties.values[iRolOptions] =
                  products[product].rolBreedte[rolSize];
                iRolOptions++;
              }
              // end loop type rol options
            }
            // end type rol
          }

          // show rol width
          if (options.rol.properties.values.length > 0) {
            options.rol.properties.show = true;
          } else {
            options.rol.properties.show = false;
          }

          // rug type
          if (
            products[product].rug !== "" &&
            !rug.includes(products[product].rug.toLowerCase())
          ) {
            rug[iRug] = products[product].rug.toLowerCase();
            options.rug.properties.values[iRug] = products[product].rug;
            iRug++;
          }

          // show rug
          if (options.rug.properties.values.length > 0) {
            options.rug.properties.show = true;
          } else {
            options.rug.properties.show = false;
          }

          // fabricage
          if (
            products[product].fabricageMethode !== "" &&
            !methode.includes(products[product].fabricageMethode.toLowerCase())
          ) {
            methode[iMethode] =
              products[product].fabricageMethode.toLowerCase();
            options.methode.properties.values[iMethode] =
              products[product].fabricageMethode;
            iMethode++;
          }

          // show fabricage
          if (options.methode.properties.values.length > 0) {
            options.methode.properties.show = true;
          } else {
            options.methode.properties.show = false;
          }

          // end products loop
        }
      }
      return options;
      // end buildFilter
    },

    setColorBtn() {
      let color = this.$store.getters.getFILTER.color;
      if (document.querySelector(".colorImg") !== null) {
        const images = document.querySelectorAll(".colorImg");
        for (let i = 0; i < images.length; i++) {
          images[i].style.display = "none";
        }
      }

      if (color !== "" && color !== undefined) {
        if (
          document.querySelector("#img" + color) !== null &&
          document.querySelector("#imgAlleKleuren") !== null
        ) {
          document.querySelector("#img" + color).style.display = "block";
          this.binds.color = color;
        }
      } else if (document.querySelector("#imgAlleKleuren") !== null) {
        document.querySelector("#imgAlleKleuren").style.display = "block";
        this.binds.color = color;
      }
    },

    setColorFilter(filterOption, value) {
      const store = {
        key: filterOption,
        value: value,
      };
      this.$store.commit("storeFILTER", store);

      this.setColorBtn();

      this.runFilter();
    },

    selected(value) {
      this.setFilter(value.key, value.value);
    },

    setFilter(filterOption, value) {
      const store = {
        key: filterOption,
        value: value,
      };
      this.$store.commit("storeFILTER", store);

      this.runFilter();
    },

    filterProducts(products, filter, value) {
      let iProduct = 0;
      let filterdProduct = [];

      for (const product in products) {
        if (typeof products[product][filter] === "object") {
          for (const index in products[product][filter]) {
            if (
              typeof products[product][filter][index] !== "number" &&
              typeof value !== "number"
            ) {
              if (
                products[product][filter][index].toLowerCase() ===
                value.toLowerCase()
              ) {
                filterdProduct[iProduct] = products[product];
                iProduct++;
              }
            } else {
              if (products[product][filter][index] === value) {
                filterdProduct[iProduct] = products[product];
                iProduct++;
              }
            }
          }
        } else if (
          products[product][filter].toLowerCase() === value.toLowerCase()
        ) {
          filterdProduct[iProduct] = products[product];
          iProduct++;
        }
      }
      return filterdProduct;
      // end filterProducts
    },

    runFilter() {
      let filterValues = this.$store.getters.getFILTER;

      // Filter on color
      if (filterValues.color !== "" && filterValues.color !== undefined) {
        this.filterResults.color = this.filterProducts(
          this.products,
          "kleurFilter",
          filterValues.color
        );
      } else {
        this.filterResults.color = this.products;
      }

      // Filter on rol
      if (filterValues.rol !== "" && filterValues.rol !== undefined) {
        this.filterResults.rol = this.filterProducts(
          this.filterResults.color,
          "rolBreedte",
          filterValues.rol
        );
      } else {
        this.filterResults.rol = this.filterResults.color;
      }

      // Filter on rug
      if (filterValues.rug !== "" && filterValues.rug !== undefined) {
        this.filterResults.rug = this.filterProducts(
          this.filterResults.rol,
          "rug",
          filterValues.rug
        );
      } else {
        this.filterResults.rug = this.filterResults.rol;
      }

      // Filter on methode
      if (filterValues.methode !== "" && filterValues.methode !== undefined) {
        this.filterResults.methode = this.filterProducts(
          this.filterResults.rug,
          "fabricageMethode",
          filterValues.methode
        );
      } else {
        this.filterResults.methode = this.filterResults.rug;
      }

      this.filterResults.final = this.filterResults.methode;

      this.options = this.buildFilter(this.products);
      this.$emit("filterd", this.filterResults.final);

      // end run filter
    },
    changeCollectie(route) {
      this.$router.push({ name: route });
    },
    showFilter() {
      this.runFilter();
      this.selection.color = this.buildColors(this.products);

      if (this.selection.color.length <= 1) {
        this.selection.colorShow = false;
      } else {
        this.selection.colorShow = true;
      }

      if (
        !this.selection.colorShow &&
        !this.selection.collectionShow &&
        !this.options.rol.properties.show &&
        !this.options.rug.properties.show &&
        !this.options.methode.properties.show
      ) {
        this.selection.filterShow = false;
      } else {
        this.selection.filterShow = true;
      }
    },
    // end methods
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
  color: #fff;
}
.accordion-height {
  height: 180px;
}

.no-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

.colorInput {
  height: 30px;
  width: 30px;
  border-radius: 15%;
  box-shadow: 0 0 5px 2px var(--WitGrijs);
}

#btn-color-All {
  background: var(--WitGrijs);
  background: linear-gradient(
    135deg,
    var(--ProdZwart) 10%,
    var(--ProdGrijs) 20%,
    var(--ProdWit) 30%,
    var(--ProdRoze) 40%,
    var(--ProdRood) 50%,
    var(--ProdOranje) 60%,
    var(--ProdGeel) 70%,
    var(--ProdGroen) 80%,
    var(--ProdBlauw) 90%
  );
}

.colorImg {
  height: 30px;
  width: 30px;
  display: none;
  border-radius: 15%;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 30px 30px;
}
</style>
